import { render, staticRenderFns } from "./originalPage.vue?vue&type=template&id=09e1030c"
import script from "./originalPage.vue?vue&type=script&lang=js"
export * from "./originalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports